import * as React from 'react';

export interface IEmptyResultsProps {
}

export class EmptyResults extends React.Component<IEmptyResultsProps, any> {

    render() {

      return (
        <div className="search-app-results-messaging">
          <div className="empty-results-message" dangerouslySetInnerHTML={{ __html: "<h5>Please enter a search query in the searchbar above to find resources on the AMTA website.</h5>" }} />
        </div>
        );
    }
}